import { Field, Layout, Title } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";
type BambooHrConfig = {
  apiKey: string;
  domain: string;
};
export const BambooHrConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as BambooHrConfig) ?? {
    apiKey: "",
    domain: ""
  };

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Api key">
        <TextInput
          placeholder="Api key"
          value={credentials.apiKey}
          type="password"
          onChange={apiKey =>
            onChange({
              credentials: { ...credentials, apiKey }
            })
          }
        />
      </Field>
      <Field title="Domain">
        <TextInput
          placeholder="Domain"
          value={credentials.domain}
          onChange={domain =>
            onChange({
              credentials: { ...credentials, domain }
            })
          }
          endAdornment={<Title>.bamboohr.com</Title>}
        />
      </Field>
    </Layout.Group>
  );
};
